// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../../generated-types'

import gql from 'graphql-tag'
export type DescriptionFragment = {
  __typename?: 'Venue'
  description?: string | null
}

export const DescriptionFragmentDoc = gql`
  fragment Description on Venue {
    description
  }
`
